import { createActions } from "redux-actions";
var prefix = "APP";
var actionTypes = ["TOGGLE_DRAWER", "SET_ONLINE", "SET_OFFLINE", "TOGGLE_SEARCH", "EXECUTE_SEARCH", "MARK_ERROR_HANDLED", "SET_PAGE_LOADING", "SET_FOOTER_VISIBLE", "SET_FOOTER_NOT_VISIBLE", "SET_PAGE_LOADER_FLAG", "REMOVE_PAGE_LOADER_FLAG", "SET_MODALS_OPENED", "SET_STORES"];
export default createActions(...actionTypes, {
  prefix
});